export type TourSubmitEventData = {
  tourStep: string | undefined;
};
class TourSubmitEvent {
  static NAME = "TOUR_SUBMIT_EVENT";

  public static dispatch(data: TourSubmitEventData) {
    document.dispatchEvent(new CustomEvent(TourSubmitEvent.NAME, { detail: data }));
  }
}
export default TourSubmitEvent;
